import { Box, Typography } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";
import { AppIconsPdf } from "../../../AppIcons";

import useBrands from "../../../../../explorer/hooks/useBrands";
import { LinkStyled } from "./FileNameComponent.style";
import useLanguages from "../../../../../explorer/hooks/useLanguages";
import { MachineDocument } from "../../../../../explorer/types/SpareParts/MachineDocument";
import {
  MACHINE_CATALOG_PDF_RESOURCES,
  MACHINE_DOCUMENTS_RESOURCES,
} from "../../../../configuration/Resources";

type TFileNameComponent = {
  item: any;
};

const FileNameComponent = (props: TFileNameComponent) => {
  const classes = useTableLayoutClasses();
  const brand = useBrands().currentBrandUrl;
  const lang = useLanguages().currentLanguage;
  const item = props.item as MachineDocument;
  const docUrl = item.isCatalogPdf
    ? MACHINE_CATALOG_PDF_RESOURCES + "/" + props.item.fileName
    : MACHINE_DOCUMENTS_RESOURCES + "/" +
      brand.toUpperCase() +
      "/" +
      props.item.fileName;
  const fileName = item.isCatalogPdf
      ? `${item.manufacturer}_${item.machineSerialNumber}.pdf`
      : `${item.fileName}`;
  return (
    <LinkStyled to={docUrl} target="_blank">
      <Box sx={[classes.columnFileName]}>
        <AppIconsPdf /> {fileName}
      </Box>
    </LinkStyled>
  );
};

export const FileDescrComponent = (props: TFileNameComponent) => {
  const lang = useLanguages().currentLanguage;
  const item = props.item as MachineDocument;
  const documentName = item.isCatalogPdf
      ? item.documentName
      : `${item.documentName}${lang !== item.lang ? " (" + item.lang + ")" : ""}`;
  return <>{documentName}</>;
};

export default FileNameComponent;
